import Vue from 'vue';
import Vuex from 'vuex';
import persistedstate from 'vuex-persistedstate'

Vue.use(Vuex);

import qrcode from '@/images/index/myqrcode.png'
import ooplogo from "@/images/index/oopvrlogo.png"
import test1 from "@/images/test/test1.jpg"
import test2 from "@/images/test/test2.jpg"
import test3 from "@/images/test/test3.jpg"
import test4 from "@/images/test/test4.jpg"
import test5 from "@/images/test/test5.jpg"
const state = {
    //用户信息
    netuser: {
        // netUserBoolean: true,
        // netUserImage: "",
        // netUserName: "OOPVR",

        // token: '',//登录用户token
    },
    //初始化web信息
    index: {
        netUserState: false,
        //设备信息
        equipment: '',
        //设备版本
        equipmentEdition: '',
        //临时令牌
        orTempKey: '',
        //用户token
        token: '',
        //用户socket
        webSocketSecretKey: '',

    },

    //web容器信息 
    boxMessage: {
        //站长微信
        ooplogo:ooplogo,
        qrcode: qrcode,
        loginbox: false,
        testImages:[{key:'1',message:'可能还没有可用资源!',images:test1},
        {key:'2',message:'可能还没有可用资源!',images:test2},
        {key:'3',message:'可能还没有可用资源!',images:test3},
        {key:'4',message:'可能还没有可用资源!',images:test4},
        {key:'5',message:'可能还没有可用资源!',images:test5}],
        initrouter: [],
        routerData: [],
    },
}
/**
 * 写入state状态
 */
const mutations = {
    setStateUser: (state, netuser) => {
        state.netuser = netuser
    },

    setNetUserState: (state, netUserState) => {
        state.index.netUserState = netUserState
    },
    // 写入临时秘钥
    setOrTempKey: (state, tempkey) => {
        state.index.orTempKey = tempkey
    },

    setToken: (state, token) => {
        state.index.token = token
    },

    setWebSocketSecretKey: (state, webSocketSecretKey) => {
        state.index.webSocketSecretKey = webSocketSecretKey
    },
    setLoginbox: (state, loginbox) => {
        state.boxMessage.loginbox = loginbox;
    },
    setEquipment: (state, equipment) => {
        state.index.equipment = equipment
    },
    setEquipmentEdition: (state, equipmentEdition) => {
        state.index.equipmentEdition = equipmentEdition
    },

    
    setRouterData: (state, routerData) => {
        state.boxMessage.routerData = routerData
    },
    setInitrouter: (state, initrouter) => {
        state.boxMessage.initrouter = initrouter
    },
}
/**
 * actions可以包含任意异步操作
 */
const actions = {


    // if (state.index.routerData.length <= 0) {
    //     get("/net/client/sort/select/")
    //       .then((response) => {
    //         if (response.code != 1) {
    //           this.$message.error(response.data, 5);
    //           return;
    //         }
    //         const routerData = getAsyncRoutes(response.data)
    //         store.commit("setRouterData", routerData)
    //         constantRouterMap.push.apply(constantRouterMap,routerData);
    //         console.log(constantRouterMap)
    //         console.log(store.state.index.routerData)
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   }
}

/**
 * 实时监听state数据变化
 */
const getters = {
    getCund: state => {
        return state.cund;
    }
}


export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    plugins: [
        persistedstate({
            key: 'vuex-backups',
            storage: window.sessionStorage,
            reducer(val) {
                return {
                    // 只储存state中的assessmentData
                    boxMessage: val.boxMessage,

                }
            }
        }),
        persistedstate({
            key: 'vuex-netUser',
            storage: window.localStorage,
            reducer(val) {
                return {
                    // 只储存state中的netuser
                    netuser: val.netuser
                }
            }
        }),
        persistedstate({
            key: 'index',
            storage: window.localStorage,
            reducer(val) {
                return {
                    // 只储存state中的index
                    index: val.index,
                }
            }
        })
    ],
});



// WEBPACK FOOTER //
// ./src/script/store/index.js